import {
  Component,
  Input,
  HostBinding,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  AfterViewInit,
} from '@angular/core';

/**
 * HeroComponent
 */
@Component({
  selector: 'ecp-hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeroComponent implements AfterViewInit {
  @HostBinding('class.hero') hero = true;
  @HostBinding('class.hero--fullsize')
  /**
   * fullsize
   */
  @Input()
  fullsize = false;
  /**
   * logo
   */
  @Input() logo: string;
  /**
   * title
   */
  @Input() title: string;
  /**
   * subtitle
   */
  @Input() subtitle: string;
  /**
   * image
   */
  @Input() image: string;

  /**
   * constructor
   * @param {ChangeDetectorRef} cdr
   */
  constructor(private cdr: ChangeDetectorRef) {}

  /**
   * getImageProperties
   * @param {string} path
   * @returns {any}
   */
  getImageProperties(path: string): any {
    const parsed = path.split(/\.(gif|jpg?g|png|webp)$/i);
    return {
      path: parsed[0],
      ext: parsed[1],
    };
  }

  /**
   * getImagePaths
   * @param {string} image
   * @returns {any}
   */
  getImagePaths(image: string): any {
    const { path, ext } = this.getImageProperties(image);
    return {
      original: image,
      large: `${path}_large.${ext}`,
      medium: `${path}_medium.${ext}`,
      small: `${path}_small.${ext}`,
    };
  }

  /**
   * ngAfterViewInit
   */
  ngAfterViewInit(): void {
    this.cdr.detach();
  }
}
